import apiClient from '../lib/axios';

export const createWorkflow = async (payload) => {
  const { data } = await apiClient.post('/api/workflows', payload);
  return data;
};

export const getMyWorkflows = async ({ workflowType, status, page = 1, limit = 10, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);

  if (workflowType) {
    params.append('workflowType', workflowType);
  }

  if (status) {
    params.append('status', status);
  }

  if (search) {
    params.append('search', search);
  }

  const { data } = await apiClient.get(`/api/workflows/my-workflows?${params.toString()}`);
  return data;
};

export const getImprestEligibility = async () => {
  const { data } = await apiClient.get('/api/workflows/imprest/eligibility');
  return data;
};

export const getAssignedWorkflows = async ({ workflowType, status, role, view, page = 1, limit = 10 } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);

  

  if (workflowType) {
    params.append('workflowType', workflowType);
  }

  if (status) {
    params.append('status', status);
  }

  if (role) {
    params.append('role', role);
  }

  if (view) {
    params.append('view', view);
  }

  

  const { data } = await apiClient.get(`/api/workflows/assigned?${params.toString()}`);
  return data;
};

export const getWorkflowById = async (id) => {
  const { data } = await apiClient.get(`/api/workflows/${id}`);
  return data;
};

export const updateWorkflow = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/workflows/${id}`, payload);
  return data;
};

export const addComment = async ({ id, comment }) => {
  const { data } = await apiClient.post(`/api/workflows/${id}/comments`, { comment });
  return data;
};

export const verifyWorkflow = async ({ id, status, comment, signature }) => {
  const { data } = await apiClient.post(`/api/workflows/${id}/verify`, { status, comment, signature });
  return data;
};

export const approveWorkflow = async ({ id, status, comment, signature }) => {
  const { data } = await apiClient.post(`/api/workflows/${id}/approve`, { status, comment, signature });
  return data;
};

export const cancelWorkflow = async ({ id, comment }) => {
  const { data } = await apiClient.post(`/api/workflows/${id}/cancel`, { comment });
  return data;
};

export const archiveWorkflow = async (id) => {
  const { data } = await apiClient.post(`/api/workflows/${id}/archive`);
  return data;
};

export const deleteWorkflow = async (id) => {
  const { data } = await apiClient.delete(`/api/workflows/${id}`);
  return data;
};

export const getPendingPayments = async ({ workflowType = 'imprest', page = 1, limit = 10 } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (workflowType) {
    params.append('workflowType', workflowType);
  }
  const { data } = await apiClient.get(`/api/workflows/payments?${params.toString()}`);
  return data;
};

export const payWorkflow = async ({ id, paymentReference, note }) => {
  const { data } = await apiClient.post(`/api/workflows/${id}/pay`, {
    paymentReference,
    note,
  });
  return data;
};

export const startRetirement = async (imprestId) => {
  const { data } = await apiClient.post(`/api/workflows/${imprestId}/start-retirement`);
  return data;
};

export const getRequisitionHistory = async (params = {}) => {
  const response = await apiClient.get('api/workflows/approved', {
    params: {
      ...params,
      view: 'done',
    },
  });

  return response.data;
};

export default createWorkflow;


